<template>
  <section>
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">Add Connection</p>
      </header>

      <div class="card">
        <section class="card-content">
          <div class="subtitle">Choose an existing connection</div>
          <b-table
            :data="$store.state.connections"
            :columns="columns"
            :selected.sync="selected"
            focusable
          >
          </b-table>

          <div class="subtitle"></div>

          <button
            class="button"
            @click="$parent.close()"
          >Cancel</button>
          <button
            v-if="!selected"
            class="button is-primary"
            disabled
          >Select a connection</button>
          <button
            v-if="selected"
            class="button is-primary"
            @click="() => { addConnection(selected); $parent.close() }"
          >Add {{ selected.name }}</button>
        </section>
      </div>

      <div class="card">
        <section class="card-content">
          <div class="subtitle">Create a new connection</div>

          <div class="columns">

            <div class="column field">
              <b-field
                label="Type of connection*"
                custom-class="is-small"
              >
                <b-input
                  @focus="$event.target.select()"
                  v-model="newConnection.type"
                  placeholder="Contractor,Agent,Inspector..."
                ></b-input>
              </b-field>
            </div>

            <div class="column field">
              <b-field
                label="Name*"
                custom-class="is-small"
              >
                <b-input
                  @focus="$event.target.select()"
                  v-model="newConnection.name"
                  placeholder="Individual or company name..."
                ></b-input>
              </b-field>
            </div>

          </div>

          <div class="columns">

            <div class="column field">
              <b-field
                label="Phone"
                custom-class="is-small"
              >
                <b-input
                  @focus="$event.target.select()"
                  v-model="newConnection.phone"
                  placeholder="Phone #"
                ></b-input>
              </b-field>
            </div>

            <div class="column field">
              <b-field
                label="Email"
                custom-class="is-small"
              >
                <b-input
                  @focus="$event.target.select()"
                  v-model="newConnection.email"
                  placeholder="Email"
                ></b-input>
              </b-field>
            </div>

          </div>

          <div class="subtitle"></div>
          <button
            class="button"
            type="button"
            @click="$parent.close()"
          >Cancel</button>
          <button
            class="button is-primary"
            @click="() => { createConnection(newConnection); $parent.close() }"
          >Create and Add</button>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import store from "@/store";

export default {
  props: {
    propertyId: String,
    stage: String
  },
  data() {
    return {
      newConnection: { type: "", name: "", phone: "", email: "" },
      data: store.state.connections,
      selected: null,
      columns: [
        {
          field: "id",
          visible: false
        },
        {
          field: "type",
          label: "Type"
        },
        {
          field: "name",
          label: "Name"
        },
        {
          field: "phone",
          label: "Phone"
        },
        {
          field: "email",
          label: "Email"
        }
      ]
    };
  },
  mounted() {
    var userId = this.$store.getters.session.user.id;
    var includeHidden = false;
    this.$store.dispatch("getUserConnections", {
      userId,
      includeHidden
    });
  },
  methods: {
    addConnection(connection) {
      var property = store.state.property;
      store.dispatch("addPropertyConnection", { property, connection });
      this.$buefy.toast.open({
        message: `Connection ${connection.name} added`,
        type: "is-success",
        duration: 3000
      });
    },
    createConnection(connection) {
      var user = store.state.session.user;
      var property = store.state.property;
      var type = connection.type;
      var name = connection.name;
      var phone = connection.phone;
      var email = connection.email;
      store
        .dispatch("newUserConnectionAddToProperty", {
          user,
          property,
          type,
          name,
          phone,
          email
        })
        .then(
          () => {
            this.$buefy.toast.open({
              message: `Connection ${name} added`,
              type: "is-success",
              duration: 3000
            });
          },
          error => {
            console.log(error);
          }
        );
    }
  }
};
</script>

<style>
</style>
